<div class="grid-container margin-top">
    <div class="grid-x">
        <div class="cell large-12 medium-12 small-12">
            <tabs (tabClicked)="onTabClicked($event)">
                <tab title="Active Wells">
                    <ag-grid-angular class="data-grid " [rowData]="active" [gridOptions]="activeGridOptions" [excelStyles]="excelStyles" aria-label="Active Wells"></ag-grid-angular>
                </tab>
                <tab title="Wells Exited the Program">
                    <ag-grid-angular class="data-grid " [rowData]="exited" [gridOptions]="exitedGridOptions" [excelStyles]="excelStyles" aria-label="Wells Exited the Program"></ag-grid-angular>
                </tab>
            </tabs>
        </div>
    </div>  
</div>
